import { Box } from "@mui/material";
import { Skeleton } from "@mui/material";
import baseStyles from "../detail/style.module.scss";
import styles from "./style.module.scss";

function SkeletonLoader() {
  return (
    <div>
      {/* Info Card */}
      <Box className={baseStyles.infoCard}>
        <div className={baseStyles.infoTop}>
          <div className={baseStyles.infoLeft}>
            <Skeleton variant="circular" width={56} height={56} />
            <div className={baseStyles.infoMeta}>
              <Skeleton variant="rounded" width={160} height={24} />
              <div className={baseStyles.metaRow}>
                <div className={baseStyles.metaCol}>
                  <Skeleton variant="text" width={40} height={16} />
                  <Skeleton variant="text" width={90} height={18} />
                </div>
                <div className={baseStyles.metaCol}>
                  <Skeleton variant="text" width={30} height={16} />
                  <Skeleton variant="text" width={70} height={18} />
                </div>
              </div>
            </div>
          </div>
          <div className={baseStyles.infoActions}>
            <Skeleton variant="rounded" width={100} height={32} sx={{ borderRadius: "20px" }} />
            <Skeleton variant="rounded" width={72} height={26} sx={{ borderRadius: "12px" }} />
          </div>
        </div>

        <hr className={baseStyles.divider} />

        <div className={baseStyles.infoIconRow}>
          {[120, 180, 100, 110, 100].map((w, i) => (
            <div key={i} className={baseStyles.infoIconItem}>
              <Skeleton variant="circular" width={18} height={18} />
              <Skeleton variant="text" width={w} height={18} />
            </div>
          ))}
        </div>
      </Box>

      {/* Form Card */}
      <Box className={baseStyles.formCard}>
        <Skeleton variant="text" width={180} height={28} sx={{ marginBottom: "20px" }} />

        {/* Students / Teachers */}
        <div className={baseStyles.twoColRow}>
          <div className={baseStyles.fieldWrapper}>
            <Skeleton variant="text" width={120} height={18} sx={{ marginBottom: "8px" }} />
            <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
          </div>
          <div className={baseStyles.fieldWrapper}>
            <Skeleton variant="text" width={120} height={18} sx={{ marginBottom: "8px" }} />
            <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
          </div>
        </div>

        {/* Multi Campus / Duration */}
        <div className={baseStyles.twoColRow}>
          <div className={baseStyles.fieldWrapper}>
            <Skeleton variant="text" width={100} height={18} sx={{ marginBottom: "8px" }} />
            <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
          </div>
          <div className={baseStyles.fieldWrapper}>
            <Skeleton variant="text" width={110} height={18} sx={{ marginBottom: "8px" }} />
            <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
          </div>
        </div>

        {/* Books Section */}
        <Box className={styles.booksSection}>
          <Skeleton variant="text" width={60} height={26} sx={{ marginBottom: "20px" }} />

          {/* Book Row — on mobile these stack vertically */}
          <div className={styles.bookRow}>
            <div className={styles.bookField}>
              <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
            </div>
            <div className={styles.bookField}>
              <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
            </div>
            <div className={styles.bookField}>
              <Skeleton variant="rounded" height={42} sx={{ borderRadius: "20px" }} />
            </div>
            <div className={styles.bookActions}>
              <Skeleton variant="circular" width={34} height={34} />
            </div>
          </div>

          <hr className={styles.booksDivider} />
          <div className={styles.totalRow}>
            <Skeleton variant="text" width={120} height={18} />
          </div>
        </Box>

        {/* Buttons */}
        <div className={baseStyles.btnContainer}>
          <Skeleton
            variant="rounded"
            height={38}
            sx={{ borderRadius: "20px", width: { xs: "100%", md: 90 } }}
          />
          <Skeleton
            variant="rounded"
            height={38}
            sx={{ borderRadius: "20px", width: { xs: "100%", md: 120 } }}
          />
        </div>
      </Box>
    </div>
  );
}

export default SkeletonLoader;
